import { render } from "./AddressDetailsComponent.vue?vue&type=template&id=8fe9ee48&scoped=true&ts=true"
import script from "./AddressDetailsComponent.vue?vue&type=script&lang=ts"
export * from "./AddressDetailsComponent.vue?vue&type=script&lang=ts"

import "./AddressDetailsComponent.vue?vue&type=style&index=0&id=8fe9ee48&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fe9ee48"]])

export default __exports__